import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const add_category = createAsyncThunk(
  'category/add_category',
  async (
    // obj,
    { enName, kuName, arName, image },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const formData = new FormData()
      formData.append('enName', enName)
      formData.append('kuName', kuName)
      formData.append('arName', arName)
      formData.append('image', image)

      const { data } = await api.post('/add-category', formData, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const add_product_property = createAsyncThunk(
  'category/add-product-property',
  async (propertyData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/add-product-property', propertyData, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const update_product_property = createAsyncThunk(
  'category/update_product_property',
  async (
    { propertyData, propertyId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post(
        '/update-product-property',
        { propertyData, propertyId },
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const delete_property = createAsyncThunk(
  'category/delete_property',
  async ({ propertyId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-property/${propertyId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_categoryId = createAsyncThunk(
  'category/get_categoryId',
  async (
    { categoryId, name, image },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const formData = new FormData()
      formData.append('name', name)
      formData.append('image', image)
      const { data } = await api.post(
        `/categoryId-get/${categoryId}`,
        formData,
        { withCredentials: true }
      )
      //console.log(data);
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_product_properties = createAsyncThunk(
  'category/get_product_properties',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-product-properties?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,

        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const category_status_update = createAsyncThunk(
  'category/category_status_update',
  async ({ categoryId, status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        `/category-status-update`,
        { categoryId, status },
        {
          withCredentials: true,
        }
      )
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_category = createAsyncThunk(
  'category/get_category',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/category-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const categoryUpdate = createAsyncThunk(
  'category/categoryUpdate',
  async (
    obj,
    // { categoryId, enName, kuName, arName },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post('/category-update', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const update_subcategory = createAsyncThunk(
  'category/update_subcategory',
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/update-sub-category', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const add_subcategory = createAsyncThunk(
  'category/add_subcategory',
  async (
    obj,

    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post('/add-sub-category', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_sub_categories = createAsyncThunk(
  'category/get_sub_categories',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_categories_subCategories = createAsyncThunk(
  'category/get_categories_subCategories',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-categories-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_sub_categories_categoryId = createAsyncThunk(
  'category/get_sub_categories_categoryId',
  async ({ categoryId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/get-subCategories-categoryId?categoryId=${categoryId}`,
        {
          withCredentials: true,
        }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


// End Method

export const category_image_update = createAsyncThunk(
  'category/category_image_update',
  async ({ categoryId, image }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const formData = new FormData()
      formData.append('image', image)
      formData.append('categoryId', categoryId)

      const { data } = await api.post(
        `/category-image-update/${categoryId}`,
        formData,
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const delete_category = createAsyncThunk(
  'category/delete_category',
  async ({ categoryId }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/delete-category/${categoryId}`, {
        withCredentials: true,
      })
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to delete category' }
      )
    }
  }
)
// End Method

export const delete_sub_category = createAsyncThunk(
  'category/delete_sub_category',
  async ({ subCategoryId }, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/delete-sub-category/${subCategoryId}`,
        {
          withCredentials: true,
        }
      )
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to delete category' }
      )
    }
  }
)
// End Method

export const categoryReducer = createSlice({
  name: 'category',
  initialState: {
    successMessage: '',
    errorMessage: '',
    loader: false,
    categorys: [],
    subCategories: [],
    subCategoriesById: [],
    subCategory: '',
    properties: [],
    productProperty: '',
    category: '',
    categoryStatus: '',
    totalCategory: 0,
    totalProperties: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_category.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(add_category.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(add_category.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.categorys = [...state.categorys, payload.category]
      })
      .addCase(add_subcategory.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(add_subcategory.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(add_subcategory.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.subCategories = [...state.subCategories, payload.subCategory]
      })

      .addCase(add_product_property.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(add_product_property.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(add_product_property.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.properties = [...state.properties, payload.productProperty]
      })

      .addCase(update_product_property.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(update_product_property.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(update_product_property.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.productProperty = payload.productProperty
      })

      .addCase(category_status_update.fulfilled, (state, { payload }) => {
        state.categoryStatus = payload.categoryStatus
        state.successMessage = payload.message
      })

      .addCase(get_product_properties.fulfilled, (state, { payload }) => {
        state.properties = payload.properties
      })

      .addCase(get_categoryId.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
      })

      .addCase(categoryUpdate.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(categoryUpdate.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(categoryUpdate.fulfilled, (state, { payload }) => {
        state.loader = false
        state.category = payload.category
        state.successMessage = payload.message
      })

      .addCase(update_subcategory.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(update_subcategory.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(update_subcategory.fulfilled, (state, { payload }) => {
        state.loader = false
        state.subCategory = payload.subCategory
        state.successMessage = payload.message
      })

      .addCase(category_image_update.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(category_image_update.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(category_image_update.fulfilled, (state, { payload }) => {
        state.loader = false
        state.category = payload.category
        // state.userInfo = payload.userInfo;
        // state.successMessage = payload.message
      })

      // .addCase(category_image_update.fulfilled, (state, { payload }) => {
      //   state.category = payload.category;
      //   // state.successMessage = payload.message;
      // })

      .addCase(get_categories_subCategories.fulfilled, (state, { payload }) => {
        state.categorys = payload.categories
      })
      .addCase(
        get_sub_categories_categoryId.fulfilled,
        (state, { payload }) => {
          state.subCategoriesById = payload.subCategories
        }
      )

      .addCase(get_sub_categories.fulfilled, (state, { payload }) => {
        state.subCategories = payload.subCategories
      })

      .addCase(get_category.fulfilled, (state, { payload }) => {
        state.totalCategory = payload.totalCategory
        state.categorys = payload.categorys
      })
      .addCase(delete_category.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.categorys = payload.categorys
      })
      .addCase(delete_category.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(delete_category.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.message
      })

      .addCase(delete_sub_category.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.subCategories = payload.subCategories
      })
      .addCase(delete_sub_category.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(delete_sub_category.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.message
      })

      .addCase(delete_property.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        // state.properties = payload.properties
      })
      .addCase(delete_property.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(delete_property.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.message
      })
  },
})
export const { messageClear } = categoryReducer.actions
export default categoryReducer.reducer
